export default "__VITE_ASSET__DyMUN0dU__"